/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `1` - Buy One Item, Get a Second Free
 * * `2` - Buy a Specific Item, Get a Different Item Free
 * * `3` - Spend a Certain Amount, Get a Free Item
 * * `4` - Half Off Drinks
 * * `5` - Special Offer
 * @export
 */
export const DealTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;
export type DealTypeEnum = typeof DealTypeEnum[keyof typeof DealTypeEnum];


export function DealTypeEnumFromJSON(json: any): DealTypeEnum {
    return DealTypeEnumFromJSONTyped(json, false);
}

export function DealTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealTypeEnum {
    return json as DealTypeEnum;
}

export function DealTypeEnumToJSON(value?: DealTypeEnum | null): any {
    return value as any;
}

